import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
/**
 * form validate mixin
 * 此 mixin 用于含有 Form 的组件中，避免重复编写 form 验证逻辑
 * 使用本 mixin 需要为每个表单组件添加 @on-change 事件处理器并
 * 调用 `validate` 方法。
 */
/**
 * @type {Vue.VueConstructor}
 */
import Vue from 'vue';
export default {
  data: function data() {
    return {
      isFormValid: false,
      formValid: {}
    };
  },
  methods: {
    /**
     * 这个方法是 mixin 的核心，iview form 组件提供的 validate 方法默认
     * 不仅仅提供验证，如果验证失败，还会将组件标红。而我们期望的效果是如
     * 果当前交互的组件验证失败，则仅仅标红当前组件，其它未交互组件保持原
     * 有状态即可，这也是本方法的核心逻辑。
     * * 如果传递了 field 参数，则验证所有字段，仅仅保留对 field 标红逻辑
     * * 如果传递了 trigger 参数，则仅仅使用 trigger 规则，这个对自定义验证
     *   很有用处，iview 表单组件默认使用 `change` 触发器，所以和表单交互时
     *   即便我们提供了其它触发器规则也不会被调用
     * * 如果传递了 form 参数，则验证指定的 form ，如果你的表单存在多 form
     *   使用此参数
     * validate(field) 验证
     * validate(field, trigger)
     * @param {string} field 要验证的字段名
     * @param {string} trigger 触发器名称
     * @param {string} form 要验证的 form ref 名
     */
    validate: function validate(field, trigger, form) {
      var _this = this;
      trigger = trigger || "";
      var originalForm = form;
      if (form) {
        form = this.$refs[form];
      }
      var forms = form ? [form] : getCurrentForms(this);
      if (field) {
        forms = forms.filter(function (form) {
          return form.fields.some(function (item) {
            return item.prop === field;
          });
        });
        if (forms.length > 1) {
          throw new Error("multiple forms has same field!");
        }
      }
      if (forms.length === 0) {
        return;
      }
      form = forms[0];
      var isValid = true;
      var count = 0;
      var onFinish = function onFinish(errors) {
        count--;
        isValid = isValid && !errors;
        if (count === 0) {
          _this.isFormValid = isValid;
          if (originalForm) {
            Vue.set(_this.formValid, "is".concat(originalForm, "Valid"), isValid);
          }
        }
      };
      form.fields.forEach(function (item) {
        count++;
        if (item.prop === field) {
          item.validate(trigger, onFinish);
        } else {
          safeValidate(item, trigger, onFinish);
        }
      });
    }
  }
};

/**
 *  获取当前组件实例上引用的 form 列表
 */
function getCurrentForms(vm) {
  var forms = [];
  Object.keys(vm.$refs).forEach(function (key) {
    var cmp = vm.$refs[key];
    if (cmp && cmp.$el && cmp.$el.tagName.toLowerCase() === "form") {
      forms.push(cmp);
    }
  });
  return forms;
}

/**
 * 安全的验证指定的表单组件
 */
function safeValidate(field, trigger, callback) {
  var validateState = field.validateState,
    validateMessage = field.validateMessage;
  field.validate(trigger, function (errors) {
    field.validateState = validateState;
    field.validateMessage = validateMessage;
    callback(errors);
  });
}